export * from './Spacer';



// WEBPACK FOOTER //
// /Users/stephan/skelware/savot/src/components/Spacer/index.jsx